import { useEffect, useState } from 'react';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import FloatingGoBackButton from '../components/widgets/FloatingGoBackButton';
import FloatingSaveButton from '../components/widgets/FloatingSaveButton';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import MainLayout from '../components/MainLayout';
import TaskManager from '../components/TaskManager';
import SideNav from '../components/SideNav';
import { Helmet } from 'react-helmet-async';
import { LuSettings2 } from 'react-icons/lu';
import SearchableDropdown from '../components/SearchableDropdown';
import InputGroup from 'react-bootstrap/InputGroup';
import { Watch } from 'react-loader-spinner';
import { Alert, Toast, ToastContainer } from 'react-bootstrap';
import { Routes, Route, useNavigate, useParams } from 'react-router-dom';

const apiUrl = process.env.REACT_APP_API_URL;

const UpdateCycleGroup = () => {
  const [cycle, setCycle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { cycleId, groupId } = useParams();

  const [showSettings, setShowSettings] = useState(false);
  const [isSharedChecklist, setIsSharedChecklist] = useState(false);
  const [sharedChecklist, setSharedChecklist] = useState('');
  const [isDesktop, setIsDesktop] = useState(false);
  const [moderator, setModerator] = useState('');
  const [cycleName, setCycleName] = useState('');
  const navigate = useNavigate();

  const [emailNotifications, setEmailNotifications] = useState(true);

  const [formState, setFormState] = useState({
    startDate: '',
    endDate: '',
    group: groupId,
    cycleMembers: [],
    emailNotifications: emailNotifications,
    sharedChecklist: sharedChecklist,
  });
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const [users, setUsers] = useState([]);
  const [userNames, setUsernames] = useState([]);

  const [dateError, setDateError] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [groupDetails, setGroupDetails] = useState();

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastType, setToastType] = useState('success');

  const handleShowToast = (message, toastType) => {
    setToastMessage(message);
    setToastType(toastType);
    setShowToast(true);
    // Toast shows for 3 seconds
  };
  const handleSelectUser = (selectedUserName) => {
    const user = users.find((u) => u.name === selectedUserName);
    if (
      user &&
      !formState.cycleMembers.some((member) => member.user === user._id)
    ) {
      const newMember = {
        user: user._id,
        goals: [],
      };
      setFormState((prev) => ({
        ...prev,
        cycleMembers: [...prev.cycleMembers, newMember],
      }));
    }
    setHasUnsavedChanges(true);
  };

  const handleChecklistUpdate = (checklist) => {
    console.log('Checklist received:', checklist);
    setSharedChecklist(checklist);
  };

  const addSubtask = (userId, goalIndex) => {
    const updatedMembers = formState.cycleMembers.map((member) =>
      member.user === userId
        ? {
            ...member,
            goals: member.goals.map((goal, index) =>
              index === goalIndex
                ? {
                    ...goal,
                    subtasks: [
                      ...goal.subtasks,
                      { subTaskName: '', isCompleted: false, isDaily: false },
                    ],
                  }
                : goal,
            ),
          }
        : member,
    );
    setFormState((prev) => ({ ...prev, cycleMembers: updatedMembers }));
    setHasUnsavedChanges(true);
  };
  const deleteGoal = (userId, goalIndex) => {
    const updatedMembers = formState.cycleMembers.map((member) =>
      member.user === userId
        ? {
            ...member,
            goals: member.goals.filter((_, index) => index !== goalIndex),
          }
        : member,
    );
    setFormState((prev) => ({ ...prev, cycleMembers: updatedMembers }));
    setHasUnsavedChanges(true);
  };
  const addGoal = (userId) => {
    const updatedMembers = formState.cycleMembers.map((member) =>
      member.user === userId
        ? {
            ...member,
            goals: [...member.goals, { goalName: '', subtasks: [] }],
          }
        : member,
    );
    setFormState((prev) => ({ ...prev, cycleMembers: updatedMembers }));
    setHasUnsavedChanges(true);
  };
  const handleSettingsToggle = () => setShowSettings(!showSettings);

  const handleSharedChecklistToggle = () => {
    console.log('I am being toggled');

    setFormState((prev) => ({
      ...prev,
      sharedChecklist: !prev.sharedChecklist, // Ensure sharedChecklist is toggled in formState
      cycleMembers: !prev.sharedChecklist
        ? prev.cycleMembers.map((member) => ({
            ...member,
            goals: [], // Reset goals if enabling shared checklist
          }))
        : prev.cycleMembers,
    }));

    setIsSharedChecklist((prev) => !prev); // Ensure UI updates with state toggle
  };
  useEffect(() => {
    const token = localStorage.getItem('token');

    const fetchCycle = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/cycles/${groupId}/${cycleId}`,
          {
            headers: { 'x-auth-token': token },
          },
        );

        const cycleData = response.data;
        console.log('response.data - ', response.data);

        // Convert ISO date to 'YYYY-MM-DD' format
        const formatDate = (isoString) =>
          isoString ? new Date(isoString).toISOString().split('T')[0] : '';

        // Transform fetched data to match createCycleGroup formState
        setFormState({
          startDate: formatDate(cycleData.startDate) || '',
          endDate: formatDate(cycleData.endDate) || '',
          group: cycleData.group || groupId, // Ensure it aligns
          cycleMembers: cycleData.cycleMembers || [],
          emailNotifications: cycleData.emailNotifications || false,
          sharedChecklist: cycleData.sharedChecklist || false,
        });
        setIsSharedChecklist(cycleData.sharedChecklist || false);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCycle();
  }, [groupId, cycleId]);

  // Dependencies ensure this runs when groupId or cycleId changes.

  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log('formState: ', formState);
    let hasEmptyGoals = false;

    const updatedCycleMembers = formState.cycleMembers.map((member) => {
      const updatedGoals = member.goals.map((goal) => {
        if (goal.subtasks.length === 0) {
          hasEmptyGoals = true;
          return {
            ...goal,
            subtasks: [{ subTaskName: '', isCompleted: false }],
          };
        }
        return goal;
      });
      return { ...member, goals: updatedGoals };
    });

    if (hasEmptyGoals) {
      setFormState((prev) => ({ ...prev, cycleMembers: updatedCycleMembers }));
      handleShowToast(
        'Each goal must have at least one subtask. Empty subtasks have been added.',
        'warning',
      );
      return;
    }

    if (!dateError) {
      const token = localStorage.getItem('token');
      try {
        if (cycleId) {
          // If editing an existing cycle
          await axios.put(`${apiUrl}/cycles/${cycleId}`, formState, {
            headers: { 'x-auth-token': token },
          });
          handleShowToast('Cycle Updated Successfully!', 'success');
        } else {
          // If creating a new cycle
          await axios.post(`${apiUrl}/cycles`, formState, {
            headers: { 'x-auth-token': token },
          });
          handleShowToast('Cycle Saved Successfully!', 'success');
        }
        setHasUnsavedChanges(false);
        navigate('..');
      } catch (error) {
        console.error(error);
        handleShowToast('Unexpected Error!', 'danger');
      }
    }
  };

  const deleteSubtask = (userId, goalIndex, subtaskIndex) => {
    const updatedMembers = formState.cycleMembers.map((member) =>
      member.user === userId
        ? {
            ...member,
            goals: member.goals.map((goal, gIndex) =>
              gIndex === goalIndex
                ? {
                    ...goal,
                    subtasks: goal.subtasks.filter(
                      (_, sIndex) => sIndex !== subtaskIndex,
                    ),
                  }
                : goal,
            ),
          }
        : member,
    );
    setFormState((prev) => ({ ...prev, cycleMembers: updatedMembers }));
    setHasUnsavedChanges(true);
  };

  const handleStartDateChange = (e) => {
    const newStartDate = e.target.value;
    if (formState.endDate && newStartDate > formState.endDate) {
      setDateError('Start date cannot be later than end date.');
    } else {
      setDateError('');
    }
    setFormState((prev) => ({ ...prev, startDate: newStartDate }));
    setHasUnsavedChanges(true);
  };

  const handleEndDateChange = (e) => {
    const newEndDate = e.target.value;
    if (formState.startDate && formState.startDate > newEndDate) {
      setDateError('End date cannot be earlier than start date.');
    } else {
      setDateError('');
    }
    setFormState((prev) => ({ ...prev, endDate: newEndDate }));
    setHasUnsavedChanges(true);
  };
  // Function to navigate back
  const navigateBack = () => {
    if (
      !hasUnsavedChanges ||
      window.confirm(
        'You have unsaved changes. Are you sure you want to leave?',
      )
    ) {
      navigate(-1);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('token'); //
    const isLoggedIn = Boolean(localStorage.getItem('token'));

    const fetchUsers = async () => {
      try {
        // if(isLoggedIn){
        const response = await axios.get(`${apiUrl}/groups/${groupId}/users`, {
          headers: {
            'x-auth-token': token,
          },
        });

        // Filter out users without a name
        const filteredUsernames = response.data
          .map((user) => user.name)
          .filter((name) => name);

        setUsernames(filteredUsernames);
        setUsers(response.data);
        console.log(response.data);

        if (groupId && isLoggedIn) {
          // Check if adminId is defined
          const response_gd = await axios.get(`${apiUrl}/groups/${groupId}`, {
            headers: {
              'x-auth-token': token,
            },
          });

          const group = response_gd.data;

          setGroupDetails(group);
          setLoading(false);
        }
      } catch (error) {
        console.error(error.message);
      }
    };
    console.log('here in ue1');
    fetchUsers();
  }, []);

  return (
    <>
      <Row>
        <Col md={2} className="sidebar">
          <SideNav />
        </Col>
        <Col md={10}>
          <Helmet>
            <title>Update Cycle</title>
            <meta
              name="description"
              content="Asquad - accountability made easy"
            />
          </Helmet>

          {loading ? (
            <div className="d-flex justify-content-center align-items-center vh-75">
              <div className="loading-section">
                <Watch
                  visible={true}
                  height="40"
                  width="40"
                  radius="48"
                  color="#4fa94d"
                  ariaLabel="watch-loading"
                  wrapperStyle={{}}
                  wrapperClass="watch-load"
                />
                <p className="loading-text">
                  "The two most powerful warriors are patience and time." – Leo
                  Tolstoy
                </p>
              </div>
            </div>
          ) : (
            <Container>
              <MainLayout title="Update Cycle">
                <p className="h-gd-title">
                  {groupDetails && groupDetails.groupname}{' '}
                </p>

                <Toast
                  onClose={() => setShowToast(false)}
                  show={showToast}
                  delay={3000}
                  autohide
                  bg={toastType === 'success' ? 'success' : 'danger'}
                  style={{
                    position: 'fixed',
                    bottom: 70,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 9999,
                    color: 'white ',
                  }}
                >
                  <Toast.Body>{toastMessage}</Toast.Body>
                </Toast>

                <Form className="form-wrapper" onSubmit={handleSubmit}>
                  {/* Start and End Date Inputs */}
                  {/* Settings Button */}
                  <Modal
                    show={showSettings}
                    onHide={handleSettingsToggle}
                    centered
                  >
                    {/* ModalStart */}
                    <Modal.Header closeButton>
                      <Modal.Title>Cycle Settings</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form>
                        <Form.Group controlId="enableEmailNotifications">
                          <Form.Check
                            type="switch"
                            label="Enable Email Notifications"
                            checked={emailNotifications}
                            onChange={() =>
                              setEmailNotifications(!emailNotifications)
                            }
                          />
                        </Form.Group>
                        <Form.Group controlId="sharedChecklist">
                          <Form.Check
                            type="switch"
                            label="Shared Checklist"
                            checked={isSharedChecklist}
                            onChange={handleSharedChecklistToggle}
                          />
                        </Form.Group>
                        {/* <Form.Group controlId="selectModerator">
                          <Form.Label>Select Moderator</Form.Label>
                          <Form.Control
                            as="select"
                            value={moderator}
                            onChange={(e) => setModerator(e.target.value)}
                          >
                            <option value="">Choose a Moderator</option>
                            {users.map((user) => (
                              <option key={user._id} value={user._id}>
                                {user.name}
                              </option>
                            ))}
                          </Form.Control>
                        </Form.Group>
                        <Form.Group controlId="cycleName">
                          <Form.Label>Cycle Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter custom cycle name"
                            value={cycleName}
                            onChange={(e) => setCycleName(e.target.value)}
                          />
                        </Form.Group> */}
                      </Form>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="primary" onClick={handleSettingsToggle}>
                        Save
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  <Row>
                    <Col md={6} lg={2} className="text-center mt-3 mt-md-0">
                      <div className="settings-set">
                        <div
                          className="settings-icon-disabled"
                          style={{
                            pointerEvents: 'none',
                            opacity: 0.5,
                            cursor: 'not-allowed',
                          }}
                        >
                          <LuSettings2
                            color="#68b422"
                            size="20"
                            fontWeight={700}
                          />
                        </div>
                        <p
                          className="settings-text"
                          style={{
                            pointerEvents: 'none',
                            opacity: 0.5,
                            cursor: 'not-allowed',
                          }}
                        >
                          {' '}
                          settings
                        </p>
                      </div>
                    </Col>
                  </Row>
                  <Row className="justify-content-center mb-3">
                    <Col md={6} lg={3}>
                      <Form.Group>
                        <Form.Label>Start Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="startDate"
                          value={formState.startDate}
                          required="true"
                          onChange={handleStartDateChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} lg={3}>
                      <Form.Group>
                        <Form.Label>End Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="endDate"
                          value={formState.endDate}
                          onChange={handleEndDateChange}
                          required="true"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* Searchable Dropdown centered under the date inputs */}
                  <Row className="justify-content-center mb-3">
                    {/* <Col md={6} lg={6}>
                      <SearchableDropdown
                        options={userNames}
                        onSelect={handleSelectUser}
                      />
                    </Col> */}
                  </Row>
                  {isSharedChecklist ? (
                    <TaskManager onChecklistUpdate={handleChecklistUpdate} />
                  ) : (
                    <>
                      <Row className="justify-content-center mb-3">
                        <Col md={6} lg={6}>
                          <SearchableDropdown
                            options={userNames}
                            onSelect={handleSelectUser}
                          />
                        </Col>
                      </Row>
                      {formState.cycleMembers.map((member, mIndex) => (
                        <div key={mIndex} className="mb-3">
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}
                          >
                            <Card.Title>{member.user.name}</Card.Title>
                            <div
                              className="add-goal-btn"
                              onClick={() => addGoal(member.user)}
                            >
                              Add Goal
                            </div>
                          </div>
                          {member.goals.map((goal, gIndex) => (
                            <div key={gIndex} className="mt-2">
                              <Card.Subtitle>
                                {`${member.user.name}'s Goal #${gIndex + 1}`}
                              </Card.Subtitle>
                              <InputGroup className="mb-2">
                                <Form.Control
                                  type="text"
                                  value={goal.goalName}
                                  onChange={(e) => {
                                    const goalName = e.target.value;
                                    setFormState((prev) => {
                                      const updatedCycleMembers =
                                        prev.cycleMembers.map((mem) =>
                                          mem.user === member.user
                                            ? {
                                                ...mem,
                                                goals: mem.goals.map((g, gi) =>
                                                  gi === gIndex
                                                    ? {
                                                        ...g,
                                                        goalName: goalName,
                                                      }
                                                    : g,
                                                ),
                                              }
                                            : mem,
                                        );
                                      return {
                                        ...prev,
                                        cycleMembers: updatedCycleMembers,
                                      };
                                    });
                                  }}
                                  placeholder="Goal Name"
                                  className="goal-input"
                                  required={true}
                                />
                                <Button
                                  className="delete-goal-btn"
                                  variant="danger"
                                  onClick={() =>
                                    deleteGoal(member.user, gIndex)
                                  }
                                >
                                  X
                                </Button>
                              </InputGroup>
                              <div
                                className="add-sbtask-btn"
                                onClick={() => addSubtask(member.user, gIndex)}
                              >
                                Add Subtask
                              </div>

                              {goal.subtasks.map((subtask, sIndex) => (
                                <InputGroup className="mb-2" key={sIndex}>
                                  <Form.Control
                                    type="text"
                                    value={subtask.subTaskName}
                                    onChange={(e) => {
                                      const subTaskName = e.target.value;
                                      setFormState((prev) => {
                                        const updatedCycleMembers =
                                          prev.cycleMembers.map((mem) =>
                                            mem.user === member.user
                                              ? {
                                                  ...mem,
                                                  goals: mem.goals.map(
                                                    (g, gi) =>
                                                      gi === gIndex
                                                        ? {
                                                            ...g,
                                                            subtasks:
                                                              g.subtasks.map(
                                                                (s, si) =>
                                                                  si === sIndex
                                                                    ? {
                                                                        ...s,
                                                                        subTaskName:
                                                                          subTaskName,
                                                                      }
                                                                    : s,
                                                              ),
                                                          }
                                                        : g,
                                                  ),
                                                }
                                              : mem,
                                          );
                                        return {
                                          ...prev,
                                          cycleMembers: updatedCycleMembers,
                                        };
                                      });
                                    }}
                                    placeholder="Subtask Name"
                                    required={true}
                                    className="subtask-input"
                                  />

                                  <div
                                    className="delete-subtask"
                                    onClick={() =>
                                      deleteSubtask(member.user, gIndex, sIndex)
                                    }
                                  >
                                    X
                                  </div>
                                </InputGroup>
                              ))}
                            </div>
                          ))}
                        </div>
                      ))}
                    </>
                  )}
                  {dateError && <Alert variant="danger">{dateError}</Alert>}
                  <FloatingGoBackButton onClick={navigateBack} />
                  <FloatingSaveButton type="submit" />
                  {/* <Button className="create-cycle-btn" type="submit" >Submit Form</Button> */}
                </Form>
              </MainLayout>
            </Container>
          )}
        </Col>
      </Row>
    </>
  );
};

export default UpdateCycleGroup;
